import { getFirestore, doc, getDoc, setDoc, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore";
import { app } from "../../firebase-config.js";
import { AdminMenuEditor } from "./AdminMenuEditor.js";

const db = getFirestore(app);

export const AdminConfigPage = async () => {
    const container = document.createElement('div');
    container.className = 'max-w-4xl mx-auto px-4 py-8 space-y-8';

    container.innerHTML = `
        <h1 class="text-2xl font-bold text-gray-900">🛠️ 환경 & 메뉴 설정</h1>
    `;

    // 1. Menu Editor Section
    const menuEditorContainer = document.createElement('div');
    container.appendChild(menuEditorContainer);
    new AdminMenuEditor(menuEditorContainer);

    // 2. External Links Section
    // Existing Logic Preserved but wrapped
    const linkSection = document.createElement('div');
    linkSection.className = "bg-white rounded-xl shadow-sm border border-gray-200 p-6";
    linkSection.innerHTML = `
        <h2 class="text-lg font-bold text-gray-800 mb-4">🔗 외부 링크 관리 (External Links)</h2>
        <p class="text-sm text-gray-500 mb-6">메뉴 내 '외부 링크 영역'에 표시될 링크를 관리합니다.</p>

        <!-- List -->
        <div id="link-list" class="space-y-3 mb-6">
            <div class="animate-pulse flex space-x-4">
                <div class="h-10 bg-gray-200 rounded w-full"></div>
            </div>
        </div>

        <!-- Add Form -->
        <div class="bg-gray-50 rounded-lg p-4 border border-gray-100">
            <h3 class="text-sm font-bold text-gray-700 mb-3">새 링크 추가</h3>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                <input type="text" id="link-label" placeholder="라벨 (예: 굿즈샵)" class="border border-gray-300 rounded px-3 py-2 text-sm">
                <input type="text" id="link-url" placeholder="URL (https://...)" class="border border-gray-300 rounded px-3 py-2 text-sm">
                <input type="text" id="link-icon" placeholder="아이콘 (Lucide/Material)" class="border border-gray-300 rounded px-3 py-2 text-sm" value="link">
            </div>
            <button id="btn-add-link" class="mt-3 w-full bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 rounded-lg text-sm transition-colors">
                추가하기
            </button>
        </div>
    `;
    container.appendChild(linkSection);


    // Link Logic
    const listContainer = linkSection.querySelector('#link-list');
    const btnAdd = linkSection.querySelector('#btn-add-link');
    const inputLabel = linkSection.querySelector('#link-label');
    const inputUrl = linkSection.querySelector('#link-url');
    const inputIcon = linkSection.querySelector('#link-icon');

    const configRef = doc(db, "settings", "config");

    const loadLinks = async () => {
        try {
            const snap = await getDoc(configRef);
            if (snap.exists() && snap.data().external_links) {
                renderList(snap.data().external_links);
            } else {
                renderList([]); // Init
            }
        } catch (e) {
            console.error(e);
            listContainer.innerHTML = `<div class="text-red-500">불러오기 실패</div>`;
        }
    };

    const renderList = (links) => {
        if (!links || links.length === 0) {
            listContainer.innerHTML = `<div class="text-gray-400 text-center py-4">등록된 링크가 없습니다.</div>`;
            return;
        }

        listContainer.innerHTML = '';
        links.forEach((link, index) => {
            const item = document.createElement('div');
            item.className = "flex items-center justify-between bg-white border border-gray-200 rounded-lg p-3 hover:shadow-sm transition-shadow";
            item.innerHTML = `
                <div class="flex items-center gap-3 overflow-hidden">
                    <div class="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-600">
                        <span class="material-symbols-outlined text-lg">${link.icon || 'link'}</span>
                    </div>
                    <div class="min-w-0">
                        <div class="font-bold text-gray-900 text-sm truncate">${link.label}</div>
                        <div class="text-xs text-gray-400 truncate">${link.url}</div>
                    </div>
                </div>
                <button class="text-red-400 hover:text-red-600 p-2" data-idx="${index}">
                    <span class="material-symbols-outlined text-lg">delete</span>
                </button>
            `;

            // Delete Logic
            item.querySelector('button').onclick = async () => {
                if (confirm(`'${link.label}' 링크를 삭제하시겠습니까?`)) {
                    await updateDoc(configRef, {
                        external_links: arrayRemove(link)
                    });
                    loadLinks(); // Reload
                }
            };

            listContainer.appendChild(item);
        });
    };

    btnAdd.onclick = async () => {
        const label = inputLabel.value.trim();
        const url = inputUrl.value.trim();
        const icon = inputIcon.value.trim() || 'link';

        if (!label || !url) {
            alert('라벨과 URL을 모두 입력해주세요.');
            return;
        }

        const newLink = { label, url, icon };

        try {
            btnAdd.disabled = true;
            btnAdd.textContent = "저장 중...";

            // SetDoc with merge to ensure doc exists
            await setDoc(configRef, {
                external_links: arrayUnion(newLink)
            }, { merge: true });

            // Reset Form and Reload
            inputLabel.value = '';
            inputUrl.value = '';
            inputIcon.value = 'link';
            loadLinks();
        } catch (e) {
            console.error(e);
            alert('저장 실패: ' + e.message);
        } finally {
            btnAdd.disabled = false;
            btnAdd.textContent = "추가하기";
        }
    };

    loadLinks();

    return container;
};
